/**
 * Legacy GroupsApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.groupsApi`) keep resolving.
 *
 * The actual GroupsApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/groups/groups-api.service.ts
 */
angular.module("acme.common.service.groupsApi", [
  "acme.common.factory.QueryStringBuilder",
]);
